export default "__VITE_PUBLIC_ASSET__63e0e33b__"